import React from 'react';
import { Routes, Navigate } from 'react-router-dom';

import { TargetForm } from './TargetForm/TargetForm';
import { ScheduleForm } from './ScheduleForm/ScheduleForm';
import { GeneralSurveyConfigureFormProps } from './ConfigureForm/types';
import { GeneralSurveyTargetFormProps } from './TargetForm/types';
import { GeneralSurveyScheduleFormProps } from './ScheduleForm/types';
import { ConfigurationLayout } from './ConfigurationLayout';
import { ConfigureForm } from './ConfigureForm/ConfigureForm';

import { useGetFormContainerProps } from '../hooks/useGetFormContainerProps';
import { SurveyTabs } from '../constants';
import { SentryRoute as Route } from '../../../App/sentry';
import {
  Typography,
  ConfirmDialog,
  useAppLayoutContextConsumer,
  LinkItem,
  Page,
} from '../../../design-system';

export type SurveyConfigurePageProps = ReturnType<typeof useGetFormContainerProps> & {
  dialogProps: {
    open: boolean;
    closeModal: () => void;
    title: string;
    onConfirmClick: () => void;
  };
  pageTitle: string;
  subtitle: string;
  configureFormProps: GeneralSurveyConfigureFormProps;
  targetFormProps: GeneralSurveyTargetFormProps;
  scheduleFormProps: GeneralSurveyScheduleFormProps;
  breadcrumbLinks: LinkItem[];
};

export const SurveyUpsertPage: React.FC<SurveyConfigurePageProps> = ({
  layoutProps,
  dialogProps,
  pageTitle,
  subtitle,
  configureFormProps,
  targetFormProps,
  scheduleFormProps,
  breadcrumbLinks,
}) => {
  useAppLayoutContextConsumer(breadcrumbLinks);
  return (
    <Page
      browserTabTitle={pageTitle}
      containerProps={{ variant: 'md' }}
      pageHeaderProps={{ title: pageTitle, subtitle }}
    >
      <ConfigurationLayout {...layoutProps}>
        <Routes>
          <Route path='' element={<Navigate to={SurveyTabs.Configure} replace />} />
          <Route path={SurveyTabs.Configure} element={<ConfigureForm {...configureFormProps} />} />

          <Route path={SurveyTabs.Target} element={<TargetForm {...targetFormProps} />} />

          <Route path={SurveyTabs.Schedule} element={<ScheduleForm {...scheduleFormProps} />} />
        </Routes>
      </ConfigurationLayout>

      <ConfirmDialog
        dialogTitle={`Cancel ${dialogProps.title}`}
        open={dialogProps.open}
        confirmButtonText='Yes'
        confirmButtonProps={{
          onClick: dialogProps.onConfirmClick,
        }}
        onClose={dialogProps.closeModal}
      >
        <Typography>
          {`Wait! If you continue, this ${dialogProps.title} will be deleted and your progress will be lost. Do you still want to cancel?`}
        </Typography>
      </ConfirmDialog>
    </Page>
  );
};
